import styled from '@emotion/styled';
import { keyframes } from '@emotion/core';
/* babel-plugin-inline-import '../assets/images/arrow-down-solid-grey.svg' */var arrowDown = 'data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHByZXNlcnZlQXNwZWN0UmF0aW89Im5vbmUiIHZpZXdCb3g9IjAgMCAzMDAgMzAwIiBmaWxsPSIjNjY2Ij4KICAgIDxwYXRoIGQ9Ik0gNSA5MAogICAgICAgICAgICBsIDE0NSAxNTgKICAgICAgICAgICAgbCAxNDUgLTE1OAogICAgICAgICAgICB6IgogICAgLz4KPC9zdmc+Cg==';
/* babel-plugin-inline-import '../assets/images/arrow-down-light-grey.svg' */var lightArrowDown = 'data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHByZXNlcnZlQXNwZWN0UmF0aW89Im5vbmUiIHZpZXdCb3g9IjAgMCAzMDAgMzAwIiBmaWxsPSIjQ0NDIj4KICAgIDxwYXRoIGQ9Ik0gNSA5MAogICAgICAgICAgICBsIDE0NSAxNTgKICAgICAgICAgICAgbCAxNDUgLTE1OAogICAgICAgICAgICB6IgogICAgLz4KPC9zdmc+Cg==';

import { focusedInputBorderColor, lightGrey, mediumGrey, menuHiliteColor, menuSelectedColor, textColor, unfocusedInputBorderColor, white } from './colors';

var fontSize = 12;
var itemStartPad = 16;
var _menuVertPad = 5;
var _itemHeight = 26;
var _buttonBorderWidth = 1;
var _listBorderWidth = 1;
var _listMaxHeight = 280;

var _arrowWidth = 14;
var _arrowRightPad = 8;

var zoomOpen = keyframes({
  '0%': {
    opacity: 0,
    transformOrigin: 'top left',
    transform: 'scaleY(0)'
  },
  '100%': {
    opacity: 1,
    transformOrigin: 'top left',
    transform: 'scaleY(1)'
  }
});

export var menuStyle = {
  menuTopPad: _menuVertPad,
  itemHeight: _itemHeight,
  animateMenu: true,
  listMaxHeight: _listMaxHeight,
  buttonBorderWidth: _buttonBorderWidth,
  listBorderWidth: _listBorderWidth,

  RSDropdownDiv: styled.div(function (props) {
    var style = {
      position: 'relative',
      boxSizing: 'border-box',
      width: '100%',
      height: '100%',
      outline: 'none',
      border: _buttonBorderWidth + 'px solid ' + unfocusedInputBorderColor,
      backgroundColor: white,
      ':active:hover': {
        boxShadow: 'inset 0 2px 4px rgba(0, 0, 0, 0.125)'
      },
      borderRadius: '3px',
      ':focus': {
        borderColor: focusedInputBorderColor
      }
    };
    if (props.menuDisabled) {
      style[':active:hover'] = {};
      style[':focus'] = {};
    }
    return style;
  }),

  MenuButton: styled.div(function (props) {
    var style = {
      cursor: 'pointer',
      textAlign: 'left',
      width: '100%',
      height: '100%',
      paddingLeft: 12,
      paddingRight: 10
    };
    if (props.menuDisabled) {
      style.cursor = 'default';
    }
    return style;
  }),

  MenuButtonLabel: styled.div(function (props) {
    var style = {
      position: 'absolute',
      top: 5,
      left: 10,
      right: _arrowWidth + _arrowRightPad + 10,
      color: textColor,
      fontSize: fontSize + 'px',
      lineHeight: fontSize * 1.25 + 'px',
      fontWeight: '400',
      letterSpacing: '0.7px',
      whiteSpace: 'nowrap',
      textOverflow: 'ellipsis',
      overflow: 'hidden'
    };
    if (props.menuDisabled) {
      style.color = lightGrey;
    }
    return style;
  }),

  MenuButtonArrow: styled.div(function (props) {
    var style = {
      position: 'absolute',
      top: 5,
      right: _arrowRightPad,
      backgroundImage: 'url(' + arrowDown + ')',
      backgroundRepeat: 'no-repeat',
      backgroundSize: '100% 100%',
      width: _arrowWidth,
      height: 14
    };
    if (props.menuDisabled) {
      style.backgroundImage = 'url(' + lightArrowDown + ')';
    }
    return style;
  }),

  MenuList: styled.ul(function (props) {
    var style = {
      position: 'absolute',
      boxSizing: 'border-box',
      top: props.listTop,
      left: props.listLeft,
      backgroundClip: 'padding-box',
      backgroundColor: white,
      borderColor: mediumGrey,
      border: _listBorderWidth + 'px solid rgba(0,0,0,.15)',
      borderRadius: '0px',
      boxShadow: '0 6px 12px rgba(0,0,0,.175)',
      listStyle: 'none',
      paddingTop: _menuVertPad,
      paddingBottom: _menuVertPad,
      paddingLeft: 0,
      height: props.menuHeight,
      width: props.menuWidth,
      maxHeight: _listMaxHeight,
      overflowY: 'auto',
      overflowX: 'hidden',
      zIndex: '1000',
      marginTop: 0,
      marginBottom: 0
    };
    if (props.animationToDo === 'showing') {
      style.animation = zoomOpen + ' 300ms linear';
    }
    if (props.animationToDo === 'hiding') {
      style.animation = zoomOpen + ' 300ms linear reverse';
    }
    return style;
  }),

  MenuItem: styled.li(function (props) {
    var style = {
      cursor: 'pointer',
      boxSizing: 'border-box',
      backgroundColor: white,
      color: textColor,
      fontSize: fontSize + 'px',
      fontWeight: 'normal',
      letterSpacing: '0',
      height: _itemHeight,
      paddingTop: 5,
      paddingLeft: itemStartPad,
      paddingRight: 0,
      textOverflow: 'ellipsis',
      whiteSpace: 'nowrap',
      textAlign: 'left'
    };
    if (props.highlight) {
      style.color = white;
      style.backgroundColor = menuHiliteColor;
    }
    if (props.selected) {
      style.color = white;
      style.cursor = 'default';
      style.backgroundColor = menuSelectedColor;
    }
    return style;
  })
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/@rosetta/rs-dropdown/es/styles/StandardDropdownStyle.js
// module id = 348
// module chunks = 0